@switch (true) {

@case(showCompanyList){

<div class="stock-wrapper">
  @if(selectedArea){
  <div class="stock-row title">
    <button class="btn btn-rounded btn-light" (click)="handleGoBackToAreaList.emit()">
      <img src="assets/icons/back.svg" alt="">
    </button>
    <span>{{selectedArea}}&nbsp;/&nbsp;{{"COMPANIES"|translate}}</span>
  </div>
  }@else {
  <div class="stock-row title">
    <span>{{"COMPANIES"|translate}}</span>
  </div>
  }

  @if(!companies()){

  <app-placeholder [message]="'No company available' | translate"></app-placeholder>

  }@else {

  <div class="stores placeholder-glow">

    @if(companies()?.length === 0){

    <div class="spinner-wrapper">
      <div class="spinner-border text-primary mx-auto" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    }

    @for(company of companies(); track $index) {
    <app-stock-button [text]="company.name + ' ' + company.country" [counters]="company.stockCounters"
      [placeholder]="company.batchStocks === undefined" (handleClick)="handleSelectCompany(company)"></app-stock-button>
    }

  </div>
  }

</div>

}

@case(showBatchStockList){

<div class="stock-wrapper other-store">
  <div class="stock-row title">
    <button class="btn btn-rounded btn-light" (click)="handleSelectCompany(null)">
      <img src="assets/icons/back.svg" alt="">
    </button>
    <span>{{selectedCompany()?.name}}&nbsp;/&nbsp;{{"STORES"|translate}}</span>
  </div>

  @if(batchStocks().length > 0){

  <div class="stocks">

    @for (stock of batchStocks(); track $index) {
    <app-batch-card [stock]="stock" (handleSelectStock)="handleSelectBatchStock($event)"></app-batch-card>
    }

  </div>

  }@else {

  <app-placeholder [message]="'No stock available for company:' | translate">
    <b>{{selectedCompany()?.name}}</b>
  </app-placeholder>
  }

</div>

}

@case (showStoreStock) {
<div class="stock-wrapper">
  <div class="hr"></div>

  <div class="stock-row title">
    <button class="btn btn-rounded btn-light" (click)="handleSelectBatchStock(null)">
      <img src="assets/icons/back.svg" alt="">
    </button>
    <span class="title">
      {{selectedCompany()?.name}}&nbsp;/&nbsp;{{selectedBatch()?.storeStocks?.storeName}}
    </span>
  </div>
  <div class="stock-row">
    <span class="title">
      {{"SAP CODE"|translate}}
    </span>
    <span>
      {{selectedBatch()?.sapcode}}
    </span>
  </div>
  <div class="stock-row">
    <span class="title">
      {{"DESCRIPTION"|translate}}
    </span>
    <span>
      {{selectedBatch()?.description}}
    </span>
  </div>
  <div class="stock-row">
    <span class="title">
      {{"PRICE"|translate}}
    </span>
    <span>
      {{sharedService.getFormattedPrice(selectedBatch()!.price, selectedBatch()!.currency)}}
      @if(selectedBatch()?.vatIncluded){
      <span class="taxes fs-6">{{'Including taxes'|translate}}</span>
      }@else {
      <span class="taxes fs-6">{{'Excluding taxes'|translate}}</span>
      }
    </span>
  </div>
  <div class="stock-row">
    <span class="title">
      {{"SIZE"|translate}}
    </span>
    <span>
      {{selectedBatch()?.size}}
    </span>
  </div>
  <div class="stock-row">
    <span class="title">
      {{"BATCH"|translate}}
    </span>
    <span>
      {{selectedBatch()?.batch}}
    </span>
  </div>
  <div class="stock-row">
    <span class="title">
      {{"DETAILS"|translate}}
    </span>
    <span>
      {{selectedBatch()?.details}}
    </span>
  </div>
  <div class="stock-row other separator"><span>{{"OTHER"|translate}}</span></div>
</div>

@if(storeStock()){
<app-my-store-stock [storeStock]="storeStock"></app-my-store-stock>
}

}

}
